const KEYS = {
  authToken: "kdsAuthToken",
  lastPage: "kdsLastPage",
  whoAmI: "kdsWhoAmI",
}

const KitchenStation = {
  isAuthenticated: () => KitchenStation.getAuthToken() !== null,

  get: (key) => {
    let value = localStorage.getItem(KEYS[key])
    if (value === undefined) return null
    return value
  },

  setAuthToken: (token) => localStorage.setItem(KEYS.authToken, token),
  getAuthToken: () => KitchenStation.get("authToken"),
  clearAuthToken: () => localStorage.removeItem(KEYS.authToken),

  setLastPage: (page) => localStorage.setItem(KEYS.lastPage, page),
  getLastPage: () => localStorage.getItem(KEYS.lastPage),

  setWhoAmI: (data) => localStorage.setItem(KEYS.whoAmI, JSON.stringify(data)),
  getWhoAmI: () => JSON.parse(localStorage.getItem(KEYS.whoAmI)),
  clearWhoAmI: () => localStorage.removeItem(KEYS.whoAmI),
}

export default KitchenStation
